module.exports = __webpack_public_path__ + "media/images/common/login_btn2-78265fc289ac275faf35261ecb1e6d7f.png";